import { render, staticRenderFns } from "./exportLibrosObsequios.vue?vue&type=template&id=fd315ad2&scoped=true"
import script from "./exportLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./exportLibrosObsequios.vue?vue&type=script&lang=js"
import style0 from "./exportLibrosObsequios.vue?vue&type=style&index=0&id=fd315ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd315ad2",
  null
  
)

export default component.exports